function countrySelectorClicked(action) {
  window.addEventListener('csclicked.um', action);
}
function signInButtonClicked(action) {
  window.addEventListener('signInIconClicked.um', action);
}

export { countrySelectorClicked, signInButtonClicked };